export { default as flattenChildren } from 'react-keyed-flatten-children';
